import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "view-forgot-password" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_password_forgot_form = _resolveComponent("password-forgot-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_password_forgot_form, {
      class: "view-forgot-password__form",
      loading: _ctx.isLoading,
      errors: _ctx.errors,
      onSubmit: _ctx.remindPassword
    }, null, 8, ["loading", "errors", "onSubmit"])
  ]))
}